import { SolutionLanding } from "./SolutionLanding";

export default function TenancyDisputes() {
  return (
    <SolutionLanding
      meta={{
        testid: "tenancy-landing-page",
        title: "WhatsApp Evidence for Tenancy & Deposit Disputes | AuditPDF",
        description:
          "Turn WhatsApp chats with a landlord or tenant into a dated PDF for an RTB hearing, deposit dispute, or notice argument. Photos stay next to the message that sent them.",
        path: "/whatsapp-evidence-tenancy-disputes",
      }}
      hero={{
        eyebrow: "For RTB, Deposit & Notice Disputes",
        headline: "Compile WhatsApp Records for Tenancy & Deposit Disputes.",
        sub: "Deposit fights and repair complaints turn on dates: when notice was sent, when the leak was reported, and which photo went with that message. Put that record in one PDF.",
      }}
      pain={{
        title: "An adjudicator will not scroll your camera roll to reconstruct the tenancy.",
        points: [
          {
            title: "Notice without a date",
            body: "A screenshot of a notice to quit, or of a message agreeing a rent change, often loses the timestamp. The dispute becomes your word against theirs about when it was sent.",
          },
          {
            title: "Photos separated from the chat",
            body: "Pictures of mould, damage, or a repaired leak live in a different folder from the message that sent them. The condition and the date no longer sit together.",
          },
          {
            title: "A thread nobody can follow",
            body: "Months of WhatsApp about keys, access, and the deposit do not survive as forty cropped images. The RTB or small-claims hearing needs the sequence.",
          },
        ],
      }}
      solution={{
        title: "Every message and photo, in the order they were sent.",
        body: "AuditPDF reads the WhatsApp export and places each message on a timeline. Images sent in the chat stay with that message, so a photo of the property is tied to the date it was sent, not to the day someone saved it.",
        bullets: [
          "Dates you can point to: Notice, repair reports, and deposit messages keep their timestamps from the export.",
          "Photos beside the message: Pictures of condition, leaks, or keys are rendered with the text that accompanied them.",
          "One numbered PDF: An adjudicator can read the exchange without unlocking a phone or opening a zip of loose images.",
          "Zero retention: The chat and the PDF are deleted after the download window. A tenancy thread is not stored for later.",
        ],
        caseLabel: "TENANCY / RTB",
      }}
      showAffidavit={false}
      workflowSteps={[
        {
          title: "Upload",
          body: "Export the conversation with the landlord, tenant, or agent and upload the zip. Include the photos that were sent in the chat.",
        },
        {
          title: "Process",
          body: "Messages are laid out in order with their attachments. The source file is hashed so the PDF can be tied back to that export.",
        },
        {
          title: "Download & Purge",
          body: "Download the bundle from a link that expires. The upload and the PDF are then deleted.",
        },
      ]}
      finalCta={{
        headline: "Submit the thread with the dates still attached.",
        sub: "Useful for an RTB case, a deposit dispute, or a notice argument. €29 for a single conversation archive.",
      }}
      crossLink={{ to: "/whatsapp-evidence-divorce-family-court", label: "For family court" }}
    />
  );
}
